<template>
  <section ref="root" class="dc-container">
    <!-- papel rasgado -->
    <div class="rasgado rasgado-top"></div>

    <!-- ===== ZAPATILLAS DE BALLET DECORATIVAS ===== -->
    <img 
      ref="zapatillaTopLeft" 
      src="@/assets/zap.png" 
      alt="" 
      class="dc-zapatilla zapatilla-tl" 
    />
    <img 
      ref="zapatillaMidRight" 
      src="@/assets/liston.png" 
      alt="" 
      class="dc-zapatilla zapatilla-mr" 
    />
    <img 
      ref="zapatillaBottomLeft" 
      src="@/assets/bola.png" 
      alt="" 
      class="dc-zapatilla zapatilla-bl" 
    />

    <!-- CONTENIDO -->
    <div class="dc-card">
      <!-- Título en dos líneas -->
      <h2 ref="title" class="dc-title">
        <span>Código</span><br />
        <span class="script">de Vestimenta</span>
      </h2>

      <!-- Etiqueta -->
      <div ref="badge" class="dc-badge"> FORMAL</div>

      <!-- Ilustración vestido / traje -->
      <img
        ref="figure"
        src="@/assets/codigo.png"
        alt="Código de vestimenta"
        class="dc-figure"
      />

      <!-- Nota -->
      <p ref="note" class="dc-note">
       Favor de reservar el color Blanco y Rosa exclusivamente para la Quinceañera.
      </p>
    </div>

    <div class="rasgado rasgado-bottom"></div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeLuxuryExact',
  setup() {
    const root = ref(null)
    const title = ref(null)
    const badge = ref(null)
    const figure = ref(null)
    const note = ref(null)
    
    // Refs para las zapatillas
    const zapatillaTopLeft = ref(null)
    const zapatillaMidRight = ref(null)
    const zapatillaBottomLeft = ref(null)

    onMounted(async () => {
      await nextTick()
      if (!root.value) return

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.value,
          start: 'top 85%',
          once: true
        }
      })

      /* TÍTULO */
      tl.from(title.value, {
        opacity: 0,
        y: -24,
        filter: 'blur(6px)',
        duration: 0.6,
        ease: 'power3.out'
      })

      /* BADGE */
      tl.from(
        badge.value,
        {
          opacity: 0,
          y: -16,
          scale: 0.98,
          duration: 0.5,
          ease: 'back.out(1.6)'
        },
        '>-0.1'
      )

      /* ANIMACIÓN INICIAL ZAPATILLAS (ORILLAS) */
      tl.from([zapatillaTopLeft.value, zapatillaMidRight.value, zapatillaBottomLeft.value], {
        opacity: 0,
        scale: 0.6,
        duration: 0.7,
        stagger: 0.15,
        ease: 'back.out(1.4)'
      }, '>-0.2')

      /* FIGURA */
      tl.from(
        figure.value,
        {
          opacity: 0,
          scale: 0.9,
          duration: 0.55,
          ease: 'power2.out'
        },
        '>-0.3'
      )

      /* ========= TEXTO DIFERENTE Y EVIDENTE ========= */
      if (note.value) {
        const words = note.value.innerText.split(' ')
        note.value.innerHTML = words
          .map(word => `<span class="word">${word}</span>`)
          .join(' ')

        const wordSpans = note.value.querySelectorAll('.word')

        tl.from(
          wordSpans,
          {
            opacity: 0,
            y: 28,                 // 👈 claramente de abajo hacia arriba
            duration: 0.6,
            ease: 'power3.out',
            stagger: 0.12          // 👈 se nota palabra por palabra
          },
          '+=0.15'                // 👈 pausa clara respecto a lo anterior
        )
      }

      /* EFECTO INFINITO DE FLOTACIÓN (LOOP) EN LAS ZAPATILLAS */
      gsap.to(zapatillaTopLeft.value, {
        y: '+=8',
        rotation: '+=3',
        duration: 2.5,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })

      gsap.to(zapatillaMidRight.value, {
        y: '-=10',
        rotation: '-=4',
        duration: 3,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        delay: 0.3
      })

      gsap.to(zapatillaBottomLeft.value, {
        y: '+=6',
        rotation: '+=4',
        duration: 2.8,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        delay: 0.6
      })
    })

    onUnmounted(() => {
      ScrollTrigger.refresh()
    })

    return { 
      root, 
      title, 
      badge, 
      figure, 
      note,
      zapatillaTopLeft,
      zapatillaMidRight,
      zapatillaBottomLeft
    }
  }
}
</script>

<style scoped>
.dc-container {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
  background: #f0c9d3;
  padding: 45px 18px 55px; /* Un poco más de padding interno para cuidar los márgenes por las imágenes */
  overflow: hidden;
  text-align: center;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background: #f0c9d3;
  z-index: 3; /* Por encima de las zapatillas si éstas tocan los bordes extremos */
  pointer-events: none;
}
.rasgado-top {
  top: 0;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}
.rasgado-bottom {
  bottom: 0;
  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}

.dc-card {
  position: relative;
  z-index: 2;
}

.dc-title {
  font-family: 'britishgruesa', cursive;
  font-size: 66px;
  color: #ffffff;
  margin: 0 0 16px;
  line-height: 1.05;
}

.dc-title .script {
  opacity: 0.9;
}

.dc-badge {
  display: inline-block;
  background: #ffffff;
  color: #333;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 12px;
  letter-spacing: 0.14em;
  padding: 8px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  margin: 4px 0 12px;
}

.dc-figure {
  width: 180px;
  margin: 10px auto 12px;
  display: block;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.15));
}

.dc-note {
  font-family: 'quote', serif;
  font-size: 20px;
  color: #ffffff;
  opacity: 0.9;
  font-style: italic;
  margin: 10px auto 18px;
}

/* ===== ESTILOS DE LAS ZAPATILLAS DE BALLET ===== */
.dc-zapatilla {
  position: absolute;
  height: auto;
  z-index: 1;
  opacity: 0 !important;
  pointer-events: none;
}

/* Ubicaciones estratégicas en las orillas */
.zapatilla-tl {
  top: 50px;  width: 180px; /* Un poco más grande para balance visual */
opacity: 0 !important;
  left: 10px;
  transform: rotate(-15deg); opacity: 0 !important;
}

.zapatilla-mr {
  top: 45%; opacity: 0 !important;
  right: -18px;
  width: 180px; /* Un poco más grande para balance visual */
}

.zapatilla-bl { opacity: 0 !important;
  top: -15px !important;
  left: -52px;  width: 180px; /* Un poco más grande para balance visual */

}

/* spans del texto animado */
.word {
  display: inline-block;
  white-space: nowrap;
}
</style>